module.exports = __webpack_public_path__ + "img/icon-globe.0bd3c775.svg";